export enum HomePages {
  login,
  signup,
}
